import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class DetalleTransaccionService {
  private showDialogFn: ((transaccion: any) => void) | undefined;

  registerShowDialog(fn: (transaccion: any) => void) {
    this.showDialogFn = fn;
  }

  triggerShowDialog(transaccion: any) {
    if (this.showDialogFn) {
      this.showDialogFn(transaccion);
    } else {
      console.error('showDialog no está registrado.');
    }
  }
}
